module.exports = __webpack_public_path__ + "img/발키리 (2).c7762344.png";